const Index = ({
    title,
    children,
    className = "",
    toolbarClassName = "",
    secondaryContent = null
}) => {
    const hasToolbar = Boolean(children || secondaryContent);

    return (
        <div className={`page-header${hasToolbar ? " has-toolbar" : ""}${className ? ` ${className}` : ""}`}>
            <div className="menu-title text-extra-bold page-header-title">
                {title}
            </div>
            {hasToolbar && (
                <>
                    {children && (
                        <div className={`page-header-toolbar${toolbarClassName ? ` ${toolbarClassName}` : ""}`}>
                            {children}
                        </div>
                    )}
                    {secondaryContent && (
                        <div className="page-header-secondary">
                            {secondaryContent}
                        </div>
                    )}
                </>
            )}
        </div>
    )
}

export default Index;
